import type { ReactNode } from 'react';

export type Tone = 'accent' | 'go' | 'info' | 'warn' | 'bad' | 'muted';

const toneClasses: Record<Tone, string> = {
  accent: 'text-accent bg-accent/12 ring-accent/40',
  go: 'text-go bg-go/12 ring-go/40',
  info: 'text-info bg-info/12 ring-info/40',
  warn: 'text-warn bg-warn/12 ring-warn/40',
  bad: 'text-bad bg-bad/12 ring-bad/40',
  muted: 'text-muted bg-white/5 ring-line',
};

interface MessageScreenProps {
  icon: ReactNode;
  tone: Tone;
  title: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
  /** Optional element shown below the content (e.g. a re-pair button). */
  footer?: ReactNode;
}

/** Centered "big icon + headline" layout shared by most screens. */
export function MessageScreen({ icon, tone, title, subtitle, children, footer }: MessageScreenProps) {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-8 px-[6vmin] text-center">
      <div
        className={`grid size-[22vmin] place-items-center rounded-full ring-[0.6vmin] ${toneClasses[tone]}`}
      >
        <div className="size-[12vmin]">{icon}</div>
      </div>
      <h1 className="max-w-[90vmin] text-balance text-[7vmin] leading-[1.05] font-extrabold tracking-tight">
        {title}
      </h1>
      {subtitle && (
        <p className="max-w-[85vmin] text-balance text-[3.4vmin] leading-snug text-muted">{subtitle}</p>
      )}
      {children}
      {footer}
    </div>
  );
}
